import React from 'react';
import { Link } from 'react-router';
import { Animated } from "react-animated-css";

class Card extends React.Component {
    render() {
        const { index, sponsor } = this.props;
        return (
            <Animated animationIn="fadeInRight" style={{ float: 'left' }} animationInDelay={50 * index}>
                <Link to={`/admin/sponsors/add/${sponsor.id}`}>
                    <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red bg-black" style={{ width: 250, height: 250 }}>
                        {sponsor.Logo && <div className="align-self-center d-flex flex-row justify-content-center" style={{ width: 200, height: 100 }}>
                            <img alt="" src={sponsor.Logo} className="align-self-center" style={{ maxWidth: 200, maxHeight: 100 }} /></div>}
                        {!sponsor.Logo && <i className="far fa-star font-50 black align-self-center" />}
                        <span className="align-self-center font-18 text-center line1 margin-top-half anton toUpper white">{sponsor.Name}</span>
                    </figure>
                </Link>
            </Animated>
        )
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/private/sponsors/partials/card.js